// =============================================================================
// api/_error.ts — Centralized Supabase error handler
// =============================================================================

export const handleSupabaseError = (error: unknown, context: string): never => {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "object" && error !== null && "message" in error
        ? String((error as { message: unknown }).message)
        : "Unknown database error";

  console.error(`[Andar360] Error in ${context.toUpperCase()}:`, message);

  throw new Error(`Operation failed in ${context}: ${message}`);
};
